module.exports = __webpack_public_path__ + "img/famofi.74ee5f19.png";